export default {"src":"/_next/static/media/vertical_menu.4fdefb46.svg","height":25,"width":5,"blurWidth":0,"blurHeight":0};